import { render, staticRenderFns } from "./TsDatastoreCreateDialog.vue?vue&type=template&id=6a2a8a0e&"
import script from "./TsDatastoreCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./TsDatastoreCreateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports